import socketService from '../service/service'
import {
  UPDATE_LOGGED_IN_USER,
  GET_CASE_INFORMATION,
  PERMITDUPLICATECHECK,
  GET_SUBMIT_CASES,
  GET_CASES,
  VIEW_DEMOGRAPHY,
} from '../../types'
// group base function
export function functionMapListener(dispatch, user) {
  const socket = socketService.getSocket()
  if (!socket) return // safety check
  socket.on('functionMapUpdated', ({ groupId }) => {
    if (user.type === groupId) {
      socket.emit('getUserPermissions', user.groupId, (res) => {
        if (res.success) {
          dispatch({
            type: UPDATE_LOGGED_IN_USER,
            payload: { ...user, ...res.data },
          })
          dispatch({
            type: GET_CASES,
            payload: { create: res.data.findAccessPermisionOpenNewCase },
          })
        } else {
          console.error('❌ Failed to fetch permissions:', res.error)
        }
      })
    }
  })
}
// step base function
export function stepBaseFucntionListner(dispatch, user, caseInformation) {
  const socket = socketService.getSocket()
  if (!socket) return // safety check
  socket.off('functionMapCaseFunctionUpdated')
  socket.on(
    'functionMapCaseFunctionUpdated',
    ({ GroupType, groupId, isAllGroup = false }) => {
      if (
        user.type === GroupType &&
        (isAllGroup || user.groupId === groupId) &&
        caseInformation?.currentStep
      ) {
        socket.emit(
          'getCasePermision',
          { groupId: user.groupId, stepId: caseInformation.currentStep },
          (res) => {
            if (res.success) {
              dispatch({
                type: GET_CASE_INFORMATION,
                payload: { ...caseInformation, ...res.data },
              })
              dispatch({
                type: PERMITDUPLICATECHECK,
                payload: { permission: res.data.findPermitToDublicateCheck },
              })
              dispatch({ type: VIEW_DEMOGRAPHY, payload: { reset: true } })
              dispatch({
                type: GET_SUBMIT_CASES,
                payload: {
                  data: {
                    permission: [
                      res.data.findPermitToSubmission,
                      res.data.findPermitToValidate,
                      res.data.findPermitToE2BGeneration,
                    ].some(Boolean),
                  },
                },
              })
            } else {
              console.error('❌ Failed to fetch permissions:', res.error)
            }
          },
        )
      }
    },
  )
}
